import { color } from '../../themer/theme/color';

export const theme = {
	background: color.state.warning,
	title: {
		fontSize: '20px',
		fontFamily: 'inherit',
	},
};
